const STOP_VALUE = Symbol('STOP_VALUE');

// hack (custom promise overriding) by Owen
/**
 * 페이지 간 axios request cancel에 대한 처리를 위해 별도의 코드를 추가합니다. ( + Promise의 stop을 처리할 수 있습니다. )
 * 본 코드는 네이티브 코드를 override하여 처리한 코드입니다.
 * 
 * 따라서 typescript의 전체 기능 중 일부를 사용할 수 없을 가능성이 있으며, 
 * 추후 수정이 권장되는 코드입니다.
 * 
 * 원시적인 수정안으로써, 각 axios 호출 부의 then catch finally 체인마다 cancel에 대한 처리를 추가적으로 해준다면
 * 현재의 동작과 같게 처리할 수 있습니다.
 * 
 * 또한 본 코드는 typescript에서 용인하지 않는 코드의 작성으로 인해 각 타입이 any로 사용할 수 없는 타입들이 쓰여 있음을 꼭 유의하시기 바랍니다.
 */

 /**
  * chrome (v8 엔진) 에서 Promise.prototype.finally 의 경우에도 내부적으로 Promise.prototype.then을 사용하는 것 같습니다.
  * (native code라서 직접 확인해보기 위해서는 v8엔진 코드를 봐야합니다만, then을 override할 때, 분명한 영향을 줍니다.)
  * 따라서 코드 작성 시기에는 finally까지도 동작하지 않도록 해주지만, 엔진의 변경 등 다양한 상황에 대응하기가 어려울 수 있기에 
  * finally의 override 또한 추가적으로 고려해보아야 합니다.
  */
(function() {
    (Promise.prototype as any)._then = Promise.prototype.then
    Promise.prototype.then = function(resolve, reject) {
        return (this as any)._then(resolve ? (res: any) => {
            if (res === STOP_VALUE) return res;
            return resolve(res);
        } : resolve, reject)
        // return (this as any)._then(resolve, reject) // origin code (커스텀 하기 전과 같이 동작)
    }
})()

export namespace CancellablePromise {
    export function stop() {
        return STOP_VALUE;
    }
}
